import View from './prototypeView';
export default View;
